import React from 'react';
import { Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LogoFull from './logo-full';
import { Paragraph } from './SimpleControls/Paragraph';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Navbar expand="lg" className="d-flex justify-content-center fs-5 text-center navbar-footer">
        <Paragraph className="d-flex justify-content-center align-items-center flex-wrap text-light fw-semibold gap-2">
          <span>Powered by My</span>
          <Link className="text-footer" to={'https://www.hobud.com'}>
            <LogoFull className="mx-2 mb-1" height='20' />
          </Link>
          <span className="fw-medium">&copy; {new Date().getFullYear()}</span>
        </Paragraph>
    </Navbar>

  );
};

export default Footer;
